// extracted by mini-css-extract-plugin
export var formButton = "styles-module__formButton___wKGe5";
export var formContainer = "styles-module__formContainer___soGdz";
export var formSubText = "styles-module__formSubText___GdGvE";
export var giftMobileErrorStyles = "styles-module__giftMobileErrorStyles___QKXMg";